// Update API_URL
const API_URL = 'https://clooper-api.ap76f32dc77r0.eu-west-2.cs.amazonlightsail.com/api/v2/';

const CMSTOKEN = '91f1eab5b5eb04858149508a4ce6f09d6d968c19d181f671b590a45e063ebc95cee90951f460af490d35b59f05efb91a118d2b101dc9963581caffff17ab0a8ac9b55f356e29194d58bd2cd38e12ce14224899c615c8bb021f81c5159fe78f05134853c334721ed736d346d35536c462a14479fb96121e8e95722b9f824c3d6b'

/* -------- Do not edit beyond here -----------*/
export const environment: any = {
  production: false,
  recaptchaKey: '6LcgEGkpAAAAANLZA6qSlzB2Seziw5J2rs9A5t_C',
  socketUrl: API_URL.replace(/^(http)/, 'ws').replace(/api\/v2\/$/, ''),
  api: API_URL,
  cmsToken: CMSTOKEN,
  websiteUrl: 'https://clooper-website.ap76f32dc77r0.eu-west-2.cs.amazonlightsail.com',
  webappUrl: 'https://clooper-webapp.ap76f32dc77r0.eu-west-2.cs.amazonlightsail.com',
  adminUrl: 'https://clooper-admin.ap76f32dc77r0.eu-west-2.cs.amazonlightsail.com',
  google_api_key: 'AIzaSyA-LCC-ocqBajZtOZToyppsEBl5iN3OFdQ',
  stripePk: 'pk_test_51GvRDZKXqhtBQOqvNrS5bq0Nh9IoVH4nvBGV3IZyKYA4WPOctB09WmBfUTiuYN0UOf5XdWYXQuUXdh5w6xraRmlb00tamuFipY',
  blogUrl: 'https://clooper.com/blog',
  pubnub: {
    publishKey: 'pub-c-eee9a542-5132-4db4-82f6-5f50d8a216dd',
    subscribeKey: 'sub-c-6f937e40-618f-11ec-8e07-d6dcb445abf2',
  },
  flutterwave_public_key: 'FLWPUBK_TEST-c5d349cee321a5c782d3de055a2817b4-X',
  imageKitWebsiteBaseUrl: 'https://ik.imagekit.io/7zxg4jpx7l8/website',
  geoapifyKey: 'f46e9b697df64c4baff98123446b8742'

}
